module.exports = __webpack_public_path__ + "img/FR - TASK book LITERACY-min.cd9ede61.png";